import * as Sentry from "@sentry/react";
import LogRocket from "logrocket";
import { createStore, compose, applyMiddleware } from "redux";

// -----------------------------------------------------------------------------

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

const store = createStore(
  compose(applyMiddleware(LogRocket.reduxMiddleware()), sentryReduxEnhancer)
);

export { store };
